import {
  EXTENSION_BRIDGE_SOURCE,
  EXTENSION_BRIDGE_VERSION,
  type ExtensionBridgeMessage,
  type ExtensionCaptureFailure,
} from '@repo/contracts/extension-bridge';

/**
 * The page half of the extension bridge: posting on this window, which the
 * extension's content script relays to its service worker.
 *
 * Every message is addressed to this page's own origin rather than `'*'` — the
 * relay runs in this same window, so there is no reason to broadcast a
 * screenshot's outcome to embedded frames.
 */

export function announceReady(): void {
  post({
    source: EXTENSION_BRIDGE_SOURCE,
    version: EXTENSION_BRIDGE_VERSION,
    kind: 'ready',
  });
}

export function replySuccess(
  requestId: string,
  ids: { projectId: string; captureId: string; sessionId: string },
): void {
  post({
    source: EXTENSION_BRIDGE_SOURCE,
    version: EXTENSION_BRIDGE_VERSION,
    kind: 'capture-result',
    ok: true,
    requestId,
    ...ids,
  });
}

export function replyFailure(
  requestId: string,
  failure: ExtensionCaptureFailure,
  message?: string,
): void {
  post({
    source: EXTENSION_BRIDGE_SOURCE,
    version: EXTENSION_BRIDGE_VERSION,
    kind: 'capture-result',
    ok: false,
    requestId,
    failure,
    message,
  });
}

export function replyReportIssueSuccess(
  requestId: string,
  ids: { projectId: string; issueId: string },
): void {
  post({
    source: EXTENSION_BRIDGE_SOURCE,
    version: EXTENSION_BRIDGE_VERSION,
    kind: 'report-issue-result',
    ok: true,
    requestId,
    ...ids,
  });
}

export function replyReportIssueFailure(
  requestId: string,
  failure: ExtensionCaptureFailure,
  message?: string,
): void {
  post({
    source: EXTENSION_BRIDGE_SOURCE,
    version: EXTENSION_BRIDGE_VERSION,
    kind: 'report-issue-result',
    ok: false,
    requestId,
    failure,
    message,
  });
}

function post(message: ExtensionBridgeMessage): void {
  window.postMessage(message, window.location.origin);
}
